import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { concat as concat$ } from 'rxjs/observable/concat';
import { from as from$ } from 'rxjs/observable/from';
import {
    ACTION_ROLES_LOAD,
    ACTION_ROLES_LOAD_BY_ID,

    ACTION_ROLES_SAVE,

    ACTION_ROLES_CREATE,

    IRoleLoadAction,
    IRoleLoadByIdAction,
    IRoleLoadFailureAction,
    IRoleLoadSuccessAction,

    IRoleSaveAction,
    IRoleSaveSuccessAction,
    IRoleSaveFailureAction,

    IRoleCreateAction,
    IRoleCreateSuccessAction,
    IRoleCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/role";
import { rolesApi } from "../services/roles";


export const
    getRolesEpic = (action$): Observable<IRoleLoadSuccessAction | IRoleLoadFailureAction> => {
        return action$
            .ofType(ACTION_ROLES_LOAD)
            .mergeMap((action: IRoleLoadAction) => {
                return rolesApi
                    .getRoles()
                    .map(response =>
                        LoadSuccess(response.roles, undefined, undefined, [], response.lookups, response.modules, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getRoleByIdEpic = (action$): Observable<IRoleLoadSuccessAction | IRoleLoadFailureAction> => {
        return action$
            .ofType(ACTION_ROLES_LOAD_BY_ID)
            .mergeMap((action: IRoleLoadByIdAction) => {
                return rolesApi
                    .getRoleById(action.id)
                    .map(response =>
                        LoadSuccess(response.role, response.formState, response.formProperties, response.formRoles, response.lookups, [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setRoleEpic = (action$): Observable<IRoleSaveSuccessAction | IRoleSaveFailureAction> => {
        return action$
            .ofType(ACTION_ROLES_SAVE)
            .mergeMap((action: IRoleSaveAction) => {
                return rolesApi
                    .setRole(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.role, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createRoleEpic = (action$): Observable<IRoleCreateSuccessAction | IRoleCreateFailureAction> => {
        return action$
            .ofType(ACTION_ROLES_CREATE)
            .mergeMap((action: IRoleCreateAction) => {
                return rolesApi
                    .createRole()
                    .map(response =>
                        CreateSuccess(
                            response.role,
                            response.formState,
                            response.formProperties,
                            response.formRoles,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }



